import { forEach } from 'lib/helpers';

import { START_DATE } from 'contexts/CruiseSearchContext/constants';
import { parseISO } from 'date-fns';
import isSameMonth from 'date-fns/isSameMonth';

export const findFirstAvailableIndices = (dateRangeCalendar) => {
	const thisYear = new Date().getFullYear();
	const thisMonth = new Date().getMonth();
	const firstMonth = dateRangeCalendar.findIndex((m) => {
		const month = m?.monthIndex;
		const year = m?.year;

		return year === thisYear && month === thisMonth;
	});
	const firstYear = dateRangeCalendar.findIndex((m) => {
		const year = m?.year;

		return year === thisYear;
	});

	return { firstMonth, firstYear };
};

export const monthsAvailable = (monthsCalendar, today, facetOptions) => {
	const getCountFacet = (monthCode) => facetOptions[START_DATE]?.[monthCode]?.count;
	const listMonths = [];

	Object.keys(monthsCalendar).forEach((year) => {
		const months = monthsCalendar[year];
		months.forEach((month) => {
			const { date } = month;
			const unavailable = date < today?.current && !isSameMonth(parseISO(date), today?.current);
			let disabled = month?.disabled || unavailable;
			disabled = getCountFacet(month?.code) === 0 ? true : disabled;
			listMonths.push({
				monthIndex: ~~month?.monthIndex,
				year: ~~year,
				disabled,
			});
		});
	});

	return listMonths;
};

export const makeInitialRangesFromStartDate = (startDate, dateRangeCalendar, dates = null) => {
	let initialMonthsRange = [];
	let initialDateRange = [];
	let initialDateRangeIndex = 0;
	let initialMonthsIndex = 0;

	if (!startDate || startDate.length === 0) {
		let { firstYear, firstMonth } = findFirstAvailableIndices(dateRangeCalendar);

		if (dates) {
			const date = dates.find((month) => !month.disabled);
			firstMonth = dateRangeCalendar.findIndex((m) => m?.year === date?.year && m?.monthIndex === date?.monthIndex);
		}

		initialDateRangeIndex = firstMonth;
		initialMonthsIndex = firstYear;

		return {
			initialMonthsRange,
			initialDateRange,
			initialDateRangeIndex,
			initialMonthsIndex,
		};
	}

	const monthCodeStart = [];
	startDate &&
		forEach(startDate, (date) => {
			const [startCode, endCode] = (date || '').split('~');
			const [yearStart, monthStart] = (startCode || '').split('-');
			const [yearEnd, monthEnd] = (endCode || '').split('-');
			monthCodeStart.push(`${yearStart}-${monthStart}`);
			const monthCodeEnd = `${yearEnd}-${monthEnd}`;
			const startMonth = dateRangeCalendar.find((m) => m?.code === monthCodeStart?.slice(-1)?.[0]);
			const endMonth = dateRangeCalendar.find((m) => m?.code === monthCodeEnd);
			const flatStartCalendar = Object.values(endMonth?.calendar).flat();
			const startDay = flatStartCalendar.find((d) => d?.code === startCode);
			const flatEndCalendar = Object.values(endMonth?.calendar).flat();
			const endDay = flatEndCalendar.find((d) => d?.code === endCode);

			if (startDay && endDay) {
				initialDateRange.push([startDay, endDay]);
			}

			if (startMonth && endMonth) {
				initialMonthsRange.push([startMonth, endMonth]);
			}
		});

	initialDateRangeIndex = Math.max(
		dateRangeCalendar.findIndex((m) => m?.code === monthCodeStart?.[0]),
		0,
	);
	initialMonthsIndex = Math.floor(initialDateRangeIndex / 12);

	return {
		initialMonthsRange,
		initialDateRange,
		initialDateRangeIndex,
		initialMonthsIndex,
	};
};

export const getDateFilters = (range, fields, positions) => {
	const dateFilter = [];
	const [startField, endField] = fields;
	const [startPosition, endPosition] = positions;
	const secondPosition = endPosition ? endPosition : startPosition;
	const secondField = endField ? endField : startField;

	if (range)
		range.forEach((date) => {
			const startDate = date[startPosition]?.[startField];
			const endDate = date[secondPosition]?.[secondField] || date[startPosition]?.[secondField];
			dateFilter.push(`${startDate}~${endDate}`);
		});

	return dateFilter;
};
